module.exports = __webpack_public_path__ + "img/arrow_right1.287cfb87.png";